<template>
  <div class="container_s">
    <el-dialog
      class="default-dialog"
      title="驳回原因"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content-max" v-loading="loading">
        <TimeAxis :list="list" />
      </div>

      <div slot="footer" align="center">
        <el-button size="small" style="width: 100px;" @click="dialogVisible = false">知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TimeAxis from '@/components/table/TimeAxis'
import { findHistoryProblem } from '@/api'
export default {
  components: { TimeAxis },
  props: {},
  created() {},
  data() {
    return {
      loading: false,
      dialogVisible: false,
      list: [],
    }
  },
  methods: {
    handleOpen(row) {
      this.dialogVisible = true
      this.getHistoryProblem(row)
    },
    async getHistoryProblem(row) {
      this.loading = true
      try {
        const { data } = await findHistoryProblem({
          cid: JSON.parse(sessionStorage.getItem("cid")),
          fkAccountApprovalId: row.id
        })
        if(data.code == 1) {
          this.loading = false
          this.list = data.data
        }
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang='less' scoped>
</style>


// WEBPACK FOOTER //
// src/pages/examine/components/HistoryProblem.vue